module.exports = __webpack_public_path__ + "static/media/main_banner.5e9076eb.png";